var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#E9FFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 15H16.5C16.1022 15 15.7206 15.158 15.4393 15.4393C15.158 15.7206 15 16.1022 15 16.5V33.5C15 33.8978 15.158 34.2794 15.4393 34.5607C15.7206 34.842 16.1022 35 16.5 35H33.5C33.8978 35 34.2794 34.842 34.5607 34.5607C34.842 34.2794 35 33.8978 35 33.5V16.5C35 16.1022 34.842 15.7206 34.5607 15.4393C34.2794 15.158 33.8978 15 33.5 15Z",
    stroke: "#63B9B4",
    strokeWidth: 1.36,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.5273C20.6625 20.5273 22.6625 19.5273 25 19.5273C27.3375 19.5273 29.3375 20.5273 31 22.5273",
    stroke: "#63B9B4",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.5C25.3978 28.5 25.7794 28.342 26.0607 28.0607C26.342 27.7794 26.5 27.3978 26.5 27C26.5 26.6022 26.342 26.2206 26.0607 25.9393C25.7794 25.658 25.3978 25.5 25 25.5C24.6022 25.5 24.2206 25.658 23.9393 25.9393C23.658 26.2206 23.5 26.6022 23.5 27C23.5 27.3978 23.658 27.7794 23.9393 28.0607C24.2206 28.342 24.6022 28.5 25 28.5Z",
    fill: "#63B9B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.5L25.004 27",
    stroke: "#63B9B4",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightnew);
export default __webpack_public_path__ + "static/media/weightnew.9c97b55d7bc046540c8d3899bf79fc2f.svg";
export { ForwardRef as ReactComponent };